import React from "react";

import { useTranslation } from "react-i18next";

import useStyles from "./styles";

interface Props {
  value: string | number;
}

const ProgressBar = (props: Props) => {
  const { value } = props;
  const { t: translate } = useTranslation();
  const classes = useStyles({ value });

  return (
    <div className={classes.progressBar}>
      <div className={classes.progress}></div>
      <div className={classes.text}>{translate("documentsUploaded")}</div>
    </div>
  );
};

export default ProgressBar;
